/**
 * Adjust Smart Banner SDK integration
 * https://github.com/adjust/smart_banner_sdk
 */

/**
 * Detect if running inside a WebView (user already has the app installed)
 * @returns {boolean}
 */
function isWebView() {
    const ua = navigator.userAgent || '';

    // iOS: has iPhone/iPad but no Safari
    const isIOS =
        /iPhone|iPad/.test(ua) || (ua.includes('Macintosh') && navigator.maxTouchPoints > 2);
    if (isIOS && !/Safari/i.test(ua)) {
        return true;
    }

    // Android: has wv marker or Version/X.X
    const isAndroid = /Android/i.test(ua);
    if (isAndroid && (/\bwv\b/i.test(ua) || /Version\/\d+\.\d+/i.test(ua))) {
        return true;
    }

    return false;
}

export function initAdjustBanner() {
    const { ADJUST_SMART_BANNER_IOS_TOKEN, ADJUST_SMART_BANNER_ANDROID_TOKEN, DEBUG } = MA.Config;

    if (!ADJUST_SMART_BANNER_IOS_TOKEN && !ADJUST_SMART_BANNER_ANDROID_TOKEN) {
        return;
    }

    if (isWebView()) {
        return;
    }

    const container = document.getElementById('adjust-banner-container');
    if (!container) {
        return;
    }

    const initSDK = () => {
        if (typeof window.AdjustSmartBanner === 'undefined') {
            global.console.warn('[AdjustBanner] SDK failed to load');
            return;
        }

        // SDK uses ES module default export
        if (window.AdjustSmartBanner.default) {
            window.AdjustSmartBanner = window.AdjustSmartBanner.default;
        }

        try {
            window.AdjustSmartBanner.init({
                logLevel: DEBUG ? 'verbose' : 'warning',
                bannerParent: container,
                appToken: {
                    ios: ADJUST_SMART_BANNER_IOS_TOKEN || '',
                    android: ADJUST_SMART_BANNER_ANDROID_TOKEN || '',
                },
            });

            // SDK requires explicit show() call after init
            if (typeof window.AdjustSmartBanner.show === 'function') {
                window.AdjustSmartBanner.show();
            }
        } catch (error) {
            global.console.error('[AdjustBanner] Init failed:', error);
        }
    };

    if (typeof window.AdjustSmartBanner !== 'undefined') {
        initSDK();
    } else {
        window.addEventListener('load', initSDK);
    }
}
